import React, { FC, forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '../button';
import { HtmlContent } from '../htmlContent/HtmlContent';

export interface PanelProps {
  children?: any;
  content: string;
  as?: any;
  highlight: boolean;
  link?: {
    url: string;
    label: string;
  };
}

interface StyledPanelProps {
  highlight: boolean;
}

export const StyledPanel = styled.div<StyledPanelProps>`
  ${({
    theme: { space, colors, borders, borderRadii, shadows, media },
    highlight,
  }) => css`
    padding: ${space.small};
    border-radius: ${borderRadii.xSmall};
    border: solid 2px ${colors.brandTwo10};
    display: flex;
    flex-direction: column;
    gap: ${space.small};
    height: 100%;
    justify-content: space-between;

    ${highlight &&
    css`
      background-color: ${colors.brandOne10};
      border-color: ${colors.brandOne100};
    `};

    @media (min-width: ${media.medium}) {
      padding: ${space.xLarge};
      gap: ${space.xLarge};
    }
  `};
`;

// JSX

export const Panel = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<PanelProps>
>(({ children, content, link, highlight, as, ...rest }, ref) => (
  <StyledPanel highlight={highlight} as={as} {...rest} ref={ref}>
    <HtmlContent>{children || content}</HtmlContent>
    {link && (
      <Button
        {...link}
        variant={highlight ? 'primary' : 'secondaryOutline'}
        arrowRight={highlight}
      />
    )}
  </StyledPanel>
));

Panel.displayName = 'Panel';

export default Panel;
